import request from "../utils/request";

export const getSystems = '/external/system/'

export function modifySystem(data: any) {
    return request.request({
        url: '/external/system/',
        method: data.id ? 'put' : 'post',
        data: data
    })
}


export function deleteSystem(systemId: number) {
    return request.request({
        url: '/external/system/',
        method: 'delete',
        params: {systemId}
    })
}
